export enum FontWeight {
    "_300" = 300,
    "_400" = 400, // default
    "_500" = 500,
    "_600" = 600,
    "_700" = 700,
}
